import { useAuth } from '../auth/AuthContext'
import type { ReactNode } from 'react'
import { Redirect, useLocation } from 'react-router-dom'

interface ProtectedRouteProps {
  children: ReactNode
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { state } = useAuth()
  const location = useLocation()
  if (state.phase !== 'authenticated') {
    // Carry where the user was headed (e.g. a /conversations/:id deep link from
    // a notification email) so login can return them there after the OTP flow.
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: location.pathname + location.search + location.hash },
        }}
      />
    )
  }
  return <>{children}</>
}

export default ProtectedRoute
